// extracted by mini-css-extract-plugin
export var closeButton = "_ca-1";
export var closeX = "_ca-3";
export var container = "_ca-0";
export var image = "_ca-2";